import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../service/navigation.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {

  constructor(
    public navigationService: NavigationService
  ) {
    console.log("navigation component created");
  }

  ngOnInit() {
    this.navigationService.setItems();
  }
}
